import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ButtonToolbar, ButtonGroup } from 'reactstrap';
import SmartButton from '../../../shared/components/SmartButton';

const CalendarMarkers = (props) => {
  const { t, showDialog, calendarMarkers } = props;
  const [markerList, setMarkerList] = useState([]);

  useEffect(() => {
    setMarkerList(calendarMarkers);
  }, [calendarMarkers]);

  const calendarListRender = () =>
    markerList.length
      ? markerList.map((calendar) => (
          <div
            className="container-identifier-marker align-items-center"
            key={calendar.uuid}
          >
            <span
              className="color-identifier"
              style={{ background: calendar.color }}
            />
            <div className="d-flex w-100 justify-content-between flex-wrap pl-2">
              <button
                type="button"
                className="calendar-btn d-flex overflow-hidden text-nowrap text-ellipsis pl-0"
                onClick={() => showDialog(calendar)}
              >
                {calendar.name}
              </button>
              <span style={{ color: '#6a2b8b' }}>
                {calendar.schoolDay
                  ? t('general.learning-school-term')
                  : t('general.unlearning-school-term')}
              </span>
            </div>
          </div>
        ))
      : null;

  return (
    <div className="d-flex flex-column w-100">
      {calendarListRender()}
      <ButtonToolbar>
        <ButtonGroup className="btn-group--justified">
          <SmartButton
            color="success"
            label={t('general.add-marking')}
            onClick={showDialog}
          />
        </ButtonGroup>
      </ButtonToolbar>
    </div>
  );
};

CalendarMarkers.propTypes = {
  t: PropTypes.func.isRequired,
  showDialog: PropTypes.func.isRequired,
  calendarMarkers: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape))
    .isRequired,
};

export default withTranslation('common')(CalendarMarkers);
